import ReactDOM from 'react-dom';
import App from './App';
import { store } from './store/store';
import { Provider } from 'react-redux';
import './styles/index.scss';

export const contactsFormWidget = {
    new: config => {
        return {
            render: () => {
                ReactDOM.render(
                    <>
                        <Provider store={store}>
                            <App config={config} />{' '}
                        </Provider>{' '}
                    </>,
                    document.querySelector(config.selector)
                );
            },
        };
    },
};

if (process.env.NODE_ENV === 'development') {
    window.tealium_data2track = [];

    let isLoggedIn = false;

    //configurator object
    const config = {
        /* id of the dom element inside which the react component is rendered */
        selector: '#root',
        /* id that will be used for the contact lens form */
        prescriptionFormId: 'contact-lens-prescription-form',
        /* id of the store  */
        storeId: 10851,
        /* id of the catalog */
        catalogId: 22701,
        /* id language */
        langId: -1,
        /* If true calls mocked data otherwise service  */
        mockRequest: true,
        /* Product ID */
        productId: 808339,
        /* CL data */
        currentProduct: {
            catalogEntry: {
                catalogEntryIdentifier: {
                    uniqueId: '808339',
                    externalIdentifier: {
                        partNumber: 'JJJJACOT06',
                        ownerID: '7000000000000000003',
                    },
                },
                description: [
                    {
                        name: 'JJJJACOT06',
                        thumbnail:
                            'https://assets.lenscrafters.com/extra/image/LensCrafters/contacts_pim/JJJJACOT06_fr.png?imwidth=',
                        fullImage:
                            'https://assets.lenscrafters.com/extra/image/LensCrafters/contacts_pim/JJJJACOT06_fr.png?imwidth=',
                        language: '-1',
                    },
                ],
                offerPrice: '$66.99',
            },
            attributes: {
                CL_DIAMETER: ['14.5'],
                CL_SPHERE_POWER: [
                    '-9.00',
                    '-8.50',
                    '-8.00',
                    '-7.50',
                    '-7.00',
                    '-6.50',
                    '-6.00',
                    '-5.75',
                    '-5.50',
                    '-5.25',
                    '-5.00',
                    '-4.75',
                    '-4.50',
                    '-4.25',
                    '-4.00',
                    '-3.75',
                    '-3.50',
                    '-3.25',
                    '-3.00',
                    '-2.75',
                    '-2.50',
                    '-2.25',
                    '-2.00',
                    '-1.75',
                    '-1.50',
                    '-1.25',
                    '-1.00',
                    '-0.75',
                    '-0.50',
                    '-0.25',
                    '-0.00',
                    '+0.25',
                    '+0.50',
                    '+0.75',
                    '+1.00',
                    '+1.25',
                    '+1.50',
                    '+1.75',
                    '+2.00',
                    '+2.25',
                    '+2.50',
                    '+2.75',
                    '+3.00',
                    '+3.25',
                    '+3.50',
                    '+3.75',
                    '+4.00',
                    '+4.25',
                    '+4.50',
                    '+4.75',
                    '+5.00',
                    '+5.25',
                    '+5.50',
                    '+5.75',
                    '+6.00',
                ],
                CL_BASE_CURVE: ['8.6'],
                CL_CYLINDER: ['-2.75', '-2.25', '-1.75', '-1.25', '-0.75'],
                CL_AXIS: [
                    '010',
                    '020',
                    '030',
                    '040',
                    '050',
                    '060',
                    '070',
                    '080',
                    '090',
                    '100',
                    '110',
                    '120',
                    '130',
                    '140',
                    '150',
                    '160',
                    '170',
                    '180',
                ],
                CL_DOMINANCE: ['False'],
            },
        },
        /* */
        maxBoxes: 8,
        defaultBoxes: 4,
        discountData: {
            annualSupplyBoxes: 8,
            sixMonthsSupplyBoxes: 4,
            annualSupplySavings: 100,
            sixMonthsSupplySavings: 40,
        },
        // function that will be called every time the form renders
        onFormRender: () => {
            console.log('form rendered');
        },
        // function that will be called every time the form values change
        onFormChange: data => {
            console.log('form state:', data);
        },
        // function that will be called every time the form is submitted
        onFormSubmit: (data, valid) => {
            console.log('form submit: ', data, valid);
        },
        // function that returns whether the user is logged in or not
        isLoggedIn: () => {
            return new Promise((resolve, _) => {
                setTimeout(() => {
                    console.log('isLoggedIn response:', isLoggedIn);
                    resolve(isLoggedIn);
                }, 1000);
            });
        },
        // function that will be called to start the login flow; the argument
        // callback is a function that receives a boolean that indicates whether
        // the login flow completed successfully
        login: callback => {
            console.log('logging in');

            setTimeout(() => {
                isLoggedIn = true;
                console.log('logged in');
                callback(true);
            }, 1000);
        },
    }; //init and render widget

    contactsFormWidget.new(config).render();
}
